import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Item from './Item'
import bemClass from './../../../utils/bemClass'
import api from './../../../api'
import './Thumbnails.css'

const cn = bemClass('Thumbnails')

class Thumbnails extends PureComponent {
    state = { items: [] }

    getApi = async () => {
        const items = await api('pages/events')
        this.setState({ items })
    }

    componentWillMount() {
        this.getApi()
    }

    render() {
        const { className } = this.props
        const { items } = this.state

        return (
            <div className={`${cn()} ${className}`}>
                <div className={cn('header')}>
                    {/* <div className={cn('search')}>
                        Search...
                    </div>
                    <div className={cn('filter')}>
                        Filtruj
                    </div> */}
                </div>
                {items.map(item => (
                    <Item
                        title={item.title}
                        image={item.image}
                        date={item.dateString}
                        hour={item.hour}
                        url={item.url}
                        archive={item.archive}
                        key={item.url}
                    />
                ))}
            </div>
        )
    }
}

Thumbnails.propTypes = {
    className: PropTypes.string,
}

Thumbnails.defaultProps = {
    className: '',
}

export default Thumbnails



// WEBPACK FOOTER //
// ./src/components/FrontPage/Thumbnails/Thumbnails.jsx